<p-confirmPopup></p-confirmPopup>
<div>
	<custom-table [config]="customTable">
	</custom-table>
	<div class="flex justify-content-end gap-2">
		<p-button [label]="trans.cancelar" [outlined]="true" severity="secondary" [disabled]="btnGuardarDisable" (onClick)="onCancelarCambios()" />
		<p-button [label]="trans.guardar" [outlined]="true" severity="success" [disabled]="btnGuardarDisable" (onClick)="onGuardarCambios()"/>
	</div>
</div>


<section>
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<p-dialog [header]="formTitle" [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false"
			[resizable]="true" [maximizable]="true"
			[breakpoints]="{'1024px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">

			<ng-template pTemplate="header">
				<CustomTitle [title]="formTitle" />
			</ng-template>		
			
			<ng-template pTemplate="content">
				<main class="grid formgrid p-fluid">
					<div class="field col-12">
						<label for="actividadId" class="ml-3">{{trans.actividad}}<span style="color: red">*</span></label>
						<div class="flex gap-1 justify-content-start">
							<p-dropdown [options]="actividades" formControlName="actividadId" appendTo="body" placeholder="Select"
								optionLabel="codificacion" optionValue="id" autoWidth="false" class="flex-grow-1">
							</p-dropdown>
							<button pButton type="button" (click)="getActividades()"icon="pi pi-refresh" class="p-button-success"></button>
							<button pButton type="button" (click)="openLink()"icon="pi pi-plus" class="p-button-help"></button>
						</div>
						<ng-container
							*ngIf="form.get('actividadId')?.invalid && form.get('actividadId')?.dirty">
							<app-form-group-error-message
								[control]="form.get('actividadId')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12 md:col-6">
						<label for="orden" class="ml-3">{{trans.orden}}<span style="color: red">*</span></label>
						<p-inputNumber inputId="integeronly" formControlName="orden" inputStyleClass="w-full" styleClass="w-full"
							class="w-full">
						</p-inputNumber>
						<ng-container
							*ngIf="form.get('orden')?.invalid && form.get('orden')?.touched">
							<app-form-group-error-message
								[control]="form.get('orden')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12 md:col-6">
						<label for="plazoFechaCierre" class="ml-3">{{trans.plazoFechaCierre}}<span style="color: red">*</span></label>
						<p-inputNumber inputId="integeronly" formControlName="plazoFechaCierre" inputStyleClass="w-full"
							styleClass="w-full" class="w-full">
						</p-inputNumber>
						<ng-container
							*ngIf="form.get('plazoFechaCierre')?.invalid && form.get('plazoFechaCierre')?.touched">
							<app-form-group-error-message
								[control]="form.get('plazoFechaCierre')"></app-form-group-error-message>
						</ng-container>
					</div>				
				</main>
			</ng-template>

			<ng-template pTemplate="footer">
				<div class="field col-12">
					<div class="flex justify-content-between">
						<button pButton type="button" [label]="trans.limpiar" iconPos="right" icon="pi pi-eraser" class="tax-app-button"
							(click)="resetForm()"></button>
						<button pButton type="submit" [label]="trans.guardar" icon="pi pi-save" iconPos="right" class="tax-app-button"
							[disabled]="!ls.hasRole(role.ADMIN_PQRSD)"></button>
					</div>
				</div>
			</ng-template>
		</p-dialog>
	</form>
</section>

<app-pqrds-config-act-historico></app-pqrds-config-act-historico>